/** Calendar hire duration includes both the start and expected finish dates. */
export function hireCalendarDays(start:string,finish:string):number|null{
 const parse=(v:string)=>{if(!/^\d{4}-\d{2}-\d{2}$/.test(v))return NaN;const n=Date.parse(v+'T12:00:00Z');return Number.isFinite(n)&&new Date(n).toISOString().slice(0,10)===v?n:NaN;};
 const first=parse(start),last=parse(finish),days=(last-first)/86400000+1;
 return Number.isInteger(days)&&days>0?days:null;
}
export function hireDurationLabel(start:string,finish:string):string{
 const days=hireCalendarDays(start,finish);if(days===null)return '';
 if(days<7)return `${days} ${days===1?'day':'days'}`;
 const weeks=Math.ceil(days*10/7)/10;
 return `${weeks} ${weeks===1?'week':'weeks'}`;
}

export type WeekRounding='exact'|'tenth-up';
export type DurationCharge={unit:'day'|'week';quantity:number;unitRate:number;amount:number;days:number};
/** Rates must be supplied in the same currency and GST basis. No missing rates are inferred. */
export function durationCharge(days:number,daily:number|null,weekly:number|null,rounding:WeekRounding|null):DurationCharge|null{
 if(!Number.isInteger(days)||days<1||daily===null||weekly===null||!Number.isFinite(daily)||!Number.isFinite(weekly)||daily<=0||weekly<=0)return null;
 if(days<7&&days*daily<weekly)return {unit:'day',quantity:days,unitRate:daily,amount:Math.round(days*daily*100)/100,days};
 if(days<=7)return {unit:'week',quantity:1,unitRate:weekly,amount:Math.round(weekly*100)/100,days};
 if(rounding!=='exact'&&rounding!=='tenth-up')return null;
 const quantity=rounding==='tenth-up'?Math.ceil(days*10/7)/10:days/7;
 return {unit:'week',quantity,unitRate:weekly,amount:Math.round(quantity*weekly*100)/100,days};
}
export function chargeQuantity(value:number){return Number(value.toFixed(4)).toString();}
